<template>
	<div>
		<Checkbox v-model="example1.isChecked" :label="example1.label" :disabled="example1.disabled">
			<template #label>
				<span>{{ example1.label }} <a href="">link</a></span>
			</template>
		</Checkbox>
		<Checkbox v-model="example2.isChecked" :label="example2.label" :disabled="example2.disabled">
			<template #label>
				{{ example2.label }}
			</template>
		</Checkbox>
		<Checkbox v-model="example3.isChecked" :label="example3.label" :disabled="example3.disabled">
			<template #label>
				{{ example3.label }}
			</template>
		</Checkbox>
		<Checkbox v-model="example4.isChecked" :label="example4.label" :disabled="example4.disabled">
			<template #label>
				{{ example4.label }}
			</template>
		</Checkbox>
	</div>
</template>

<script>
import Vue from 'vue';

import Checkbox from '@/components/common/form-components/checkbox';
export default Vue.extend({
	name: 'CheckboxExample',
	data() {
	  return {
			example1: {
				label: 'isChecked: false, disabled: false',
				isChecked: false,
				disabled: false,
			},
			example2: {
				label: 'isChecked: false, disabled: true',
				isChecked: false,
				disabled: true,
			},
			example3: {
				label: 'isChecked: true, disabled: false',
				isChecked: true,
				disabled: false,
			},
			example4: {
				label: 'isChecked: true, disabled: false',
				isChecked: true,
				disabled: true,
			},
		};
	},
	components: { Checkbox }
});
</script>
